import { createSelector } from 'reselect';
import { chain } from 'lodash';
import { UI_LANGUAGES } from 'constants/languages';

export const selectApp = (state) => state.app;

export const selectUILanguage = createSelector(selectApp, (app) => app.UILanguage);

export const selectUILanguageTitleKey = createSelector(selectUILanguage, (lang) =>
  chain(UI_LANGUAGES).find({ name: lang }).get('titleKey').value(),
);

export const selectIsSomeOverlayOpen = ({ modal, overlay, loader, EPGWidget }) => {
  return !!modal.modalType || overlay.show || loader.isLoading || EPGWidget.isVisible;
};

export const selectAuthSteps = createSelector(selectApp, ({ authSteps }) => authSteps);
